import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Paper,
} from '@mui/material';
import {
  ShoppingCart,
  People,
  Inventory,
  AttachMoney,
} from '@mui/icons-material';

const Dashboard: React.FC = () => {
  // Mock de dados (será substituído por API)
  const stats = [
    {
      title: 'Pedidos Hoje',
      value: '24',
      icon: <ShoppingCart sx={{ fontSize: 40, color: '#ee44aa' }} />,
      color: '#ee44aa',
    },
    {
      title: 'Clientes Ativos',
      value: '1,428',
      icon: <People sx={{ fontSize: 40, color: '#00bcd4' }} />,
      color: '#00bcd4',
    },
    {
      title: 'Produtos',
      value: '3,642',
      icon: <Inventory sx={{ fontSize: 40, color: '#4caf50' }} />,
      color: '#4caf50',
    },
    {
      title: 'Faturamento',
      value: 'R$ 12,458',
      icon: <AttachMoney sx={{ fontSize: 40, color: '#ff9800' }} />,
      color: '#ff9800',
    },
  ];

  return (
    <Box>
      <Typography 
        variant="h4" 
        component="h1" 
        gutterBottom 
        sx={{ 
          fontWeight: 'bold',
          fontFamily: 'Arial, sans-serif',
          fontSize: '2.125rem',
          lineHeight: 1.235
        }}
      >
        Dashboard
      </Typography>
      
      <Box sx={{ flexGrow: 1 }}>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(4, 1fr)' }, gap: 3 }}>
          {stats.map((stat, index) => (
            <Card
              key={index}
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: '0.3s',
                '&:hover': {
                  transform: 'translateY(-5px)',
                  boxShadow: 3,
                },
              }}
            >
              <CardContent sx={{ flexGrow: 1, textAlign: 'center' }}>
                <Box sx={{ mb: 2 }}>{stat.icon}</Box>
                <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
                  {stat.value}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {stat.title}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>

        <Box sx={{ mt: 4 }}>
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '2fr 1fr' }, gap: 3 }}>
            <Paper sx={{ p: 3, height: 400 }}>
              <Typography variant="h6" gutterBottom>
                Gráfico de Vendas
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: 'calc(100% - 40px)',
                  color: 'text.secondary',
                }}
              >
                <Typography variant="body2">
                  Gráfico de vendas será implementado aqui
                </Typography>
              </Box>
            </Paper>
            <Paper sx={{ p: 3, height: 400 }}>
              <Typography variant="h6" gutterBottom>
                Atividades Recentes
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: 'calc(100% - 40px)',
                  color: 'text.secondary',
                }}
              >
                <Typography variant="body2">
                  Lista de atividades recentes será implementada aqui
                </Typography>
              </Box>
            </Paper>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;
